// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__q8cG3","animatedSection":"styles_animatedSection__YO4dS"};